import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ConfigurationService, PortalConfigurationService, TrackingV2Service } from '@draeger-academy/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-iframe',
    templateUrl: './iframe.component.html',
    styleUrls: ['./iframe.component.scss'],
    standalone: false
})
export class IframeComponent implements OnInit {
    @Input() portalId: any;
    @Output() iframeLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();
    public url: SafeResourceUrl;
    private _isFirstLoad = true;
    private _iframeHost = 'https://training.draeger.com/academy';
    public portal: string;
    public portalForTracking: string;
    private _$iFrameData: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    public iFrameData: { src?: SafeResourceUrl; height?: string; width?: string } = {};
    @ViewChild('iFrameSection') iFrameSection: ElementRef;

    private firstPageHasParamsToLoad = false;
    private firstPageToLoad = null;

    constructor(
        private _configurationService: ConfigurationService,
        private _activatedRoute: ActivatedRoute,
        private _portalConfigurationService: PortalConfigurationService,
        private _trackingV2Service: TrackingV2Service
    ) {}

    public get iFrameData$(): Observable<any> {
        return this._$iFrameData.asObservable();
    }

    ngOnInit(): void {
        if (this.portalId) {
            let _params = null;
            this._activatedRoute.queryParams.subscribe((params) => {
                _params = params;
            });
            const _partnerIframeSrc = this._configurationService.globalConfiguration$.filter(
                (setting) => setting.key === 'partnerIframeSrc'
            );

            if (_partnerIframeSrc && _partnerIframeSrc.length > 0) {
                this._iframeHost = _partnerIframeSrc[0].value[0].src;
            }
            if (window.addEventListener) {
                window.addEventListener('message', this.receiveMessage.bind(this), false);
            }

            const _id = this.portalId.toLowerCase();
            const _parameterUrl = _params['url'];
            const _parameterLanguage = this._portalConfigurationService.getStoredLanguage(this.portalId);
            let _url = this._iframeHost + '/' + _id;

            this._configurationService.getConfigPartnerByPortal().then((data) => {
                if (data) {
                    let tempLanding = data.filter((setting) => setting.key === 'landingPage');
                    let tempLandingHasParam = data.filter((setting) => setting.key === 'hasParams');

                    this.firstPageToLoad = tempLanding[0].value;
                    this.firstPageHasParamsToLoad = tempLandingHasParam[0].value;

                    if (this.firstPageToLoad) {
                        if (this.firstPageHasParamsToLoad) {
                            _url = _parameterLanguage
                                ? _url + this.firstPageToLoad + '&L=' + _parameterLanguage.toUpperCase()
                                : _url + this.firstPageToLoad;
                        } else {
                            _url = _url + this.firstPageToLoad;
                        }
                    } else if (_parameterUrl) {
                        _url = _parameterUrl ? _url + '/' + _parameterUrl : _url + '/index.jsp';
                    } else {
                        _url = _parameterLanguage ? _url + '/index.jsp?L=' + _parameterLanguage.toUpperCase() : _url + '/index.jsp';
                    }

                    this.iFrameData.src = _url;
                    this._$iFrameData.next(this.iFrameData.src);
                } else {
                    if (_parameterUrl) {
                        _url = _parameterUrl ? _url + '/' + _parameterUrl : _url + '/index.jsp';
                    } else {
                        _url = _parameterLanguage ? _url + '/index.jsp?L=' + _parameterLanguage.toUpperCase() : _url + '/index.jsp';
                    }
                    this.iFrameData.src = _url;
                    this._$iFrameData.next(this.iFrameData.src);
                }
            });
        }
        this._configurationService.currentPortal$.subscribe((portal) => {
            if (portal) {
                this.portal = portal;
                this.portalForTracking = this.portal.toUpperCase().replace(new RegExp('-', 'g'), '_');
                this._trackPage();
            }
        });
    }

    private _trackPage() {
        this._trackingV2Service.loadTrackingScript();
        this._trackingV2Service.trackPage({
            template: 'IFramePage',
            title: 'Dräger Academy Partnerportal ' + this.portalForTracking + ' | IFrame Page'
        });
    }

    receiveMessage(event) {
        if (!window || !event.data || typeof event.data !== 'string' || event.data.indexOf(':') === -1) return;
        const _message = event.data.split(':');
        const _eventName = _message[0];
        const _senderDomains = this._iframeHost;
        if (_senderDomains.indexOf(event.origin) !== -1 && _eventName === 'resize') {
            const _iFrame = this.iFrameSection.nativeElement;
            if ((_iFrame.contentWindow || _iFrame.documentWindow) == event.source) {
                _iFrame.style.height = `${_message[1]}px`;
            }
        }
    }
}
